import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedCountry = _resolveComponent("SharedCountry")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_SharedDate = _resolveComponent("SharedDate")!
  const _component_UIInput = _resolveComponent("UIInput")!
  const _component_SharedRadio = _resolveComponent("SharedRadio")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('header-content'))
        }, [
          _createElementVNode("h3", {
            class: _normalizeClass(_ctx.b('header-title'))
          }, _toDisplayString(_ctx.$t("Основная информация об организации")), 3),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.b('header-label'))
          }, _toDisplayString(_ctx.$t(
              "Ответьте на следующие вопросы, чтобы получить список необходимых документов"
            )), 3)
        ], 2)
      ], 2),
      _createElementVNode("form", {
        class: _normalizeClass(_ctx.b('form')),
        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleContinue && _ctx.handleContinue(...args)), ["prevent"]))
      }, [
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.b('form-section'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('form-section-title'))
          }, _toDisplayString(_ctx.$t("Регистрация")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('form-grid', { registration: true }))
          }, [
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-country')),
              field: "country",
              value: _ctx.kybBasicInfo.country,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.country,
              "onUpdate:fieldValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kybBasicInfoFields.country) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("В какой стране зарегистрирована ваша организация?")), 1),
                    _hoisted_1
                  ], 2),
                  _createVNode(_component_SharedCountry, {
                    view: "light",
                    placeholder: "Выберите страну",
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.country,
                    value: _ctx.kybBasicInfo.country,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kybBasicInfo.country) = $event))
                  }, null, 8, ["is-readonly", "is-error", "value"])
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"]),
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-date')),
              field: "registration_date",
              value: _ctx.kybBasicInfo.registration_date,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.registration_date,
              "onUpdate:fieldValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.kybBasicInfoFields.registration_date) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Дата регистрации")), 1),
                    _hoisted_2
                  ], 2),
                  _createVNode(_component_SharedDate, {
                    view: "light",
                    format: "dd-MM-yyyy",
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.registration_date,
                    date: _ctx.kybBasicInfo.registration_date,
                    "onUpdate:date": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kybBasicInfo.registration_date) = $event))
                  }, null, 8, ["is-readonly", "is-error", "date"])
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"]),
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "organisation",
              value: _ctx.kybBasicInfo.organisation,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.organisation,
              "onUpdate:fieldValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.kybBasicInfoFields.organisation) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Как называется ваша организация?")), 1),
                    _hoisted_3
                  ], 2),
                  _createVNode(_component_UIInput, {
                    view: "light",
                    placeholder: "ООО «Пример»",
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.organisation,
                    modelValue: _ctx.kybBasicInfo.organisation,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.kybBasicInfo.organisation) = $event))
                  }, null, 8, ["is-readonly", "is-error", "modelValue"]),
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.b('form-hint'))
                  }, _toDisplayString(_ctx.$t(
                    "Полное название как в уставе, включая организационно-правовую форму."
                  )), 3)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"]),
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "regional_number",
              value: _ctx.kybBasicInfo.regional_number,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.regional_number,
              "onUpdate:fieldValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.kybBasicInfoFields.regional_number) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Какой у вас регистрационный номер?")), 1),
                    _hoisted_4
                  ], 2),
                  _createVNode(_component_UIInput, {
                    view: "light",
                    placeholder: "1234567890123",
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.regional_number,
                    modelValue: _ctx.kybBasicInfo.regional_number,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.kybBasicInfo.regional_number) = $event))
                  }, null, 8, ["is-readonly", "is-error", "modelValue"]),
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.b('form-hint'))
                  }, _toDisplayString(_ctx.$t("Для РФ — ОГРН, 13 цифр.")), 3)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"])
          ], 2)
        ], 2),
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.b('form-section'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('form-section-title'))
          }, _toDisplayString(_ctx.$t("Налоги и капитал")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('form-grid'))
          }, [
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "inn",
              value: _ctx.kybBasicInfo.inn,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.inn,
              "onUpdate:fieldValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.kybBasicInfoFields.inn) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Номер налогоплательщика")), 1),
                    _hoisted_5
                  ], 2),
                  _createVNode(_component_UIInput, {
                    view: "light",
                    placeholder: "7701234567",
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.inn,
                    modelValue: _ctx.kybBasicInfo.inn,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.kybBasicInfo.inn) = $event))
                  }, null, 8, ["is-readonly", "is-error", "modelValue"])
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"]),
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "capital",
              value: _ctx.authorized_capital_amount,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.capital,
              "onUpdate:fieldValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.kybBasicInfoFields.capital) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Уставный капитал")), 1),
                    _hoisted_6
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.b('form-capital'))
                  }, [
                    _createVNode(_component_UIInput, {
                      view: "light",
                      type: "number",
                      step: "0.01",
                      placeholder: "100 000",
                      "is-readonly": _ctx.isReadonly,
                      "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.capital,
                      modelValue: _ctx.authorized_capital_amount,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.authorized_capital_amount) = $event))
                    }, null, 8, ["is-readonly", "is-error", "modelValue"]),
                    _createVNode(_component_UIInput, {
                      view: "light",
                      placeholder: "RUB",
                      "is-readonly": _ctx.isReadonly,
                      "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.capital,
                      modelValue: _ctx.authorized_capital_currency,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.authorized_capital_currency) = $event))
                    }, null, 8, ["is-readonly", "is-error", "modelValue"])
                  ], 2),
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.b('form-hint'))
                  }, _toDisplayString(_ctx.$t("Введите сумму и валюту. Например: 100 000 RUB")), 3)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"])
          ], 2)
        ], 2),
        _createElementVNode("section", {
          class: _normalizeClass(_ctx.b('form-section'))
        }, [
          _createElementVNode("h4", {
            class: _normalizeClass(_ctx.b('form-section-title'))
          }, _toDisplayString(_ctx.$t("Деятельность и контакты")), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('form-grid'))
          }, [
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "licensed",
              value: _ctx.kybBasicInfo.licensed,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.licensed,
              "onUpdate:fieldValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.kybBasicInfoFields.licensed) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Ваша деятельность лицензируется?")), 1),
                    _hoisted_7
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.b('form-radios'))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.b('form-radio', { active: _ctx.kybBasicInfo.licensed })),
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleLicensedChange(true)))
                    }, [
                      _createVNode(_component_SharedRadio, {
                        view: "light",
                        "checked-value": true,
                        "is-readonly": _ctx.isReadonly,
                        value: _ctx.kybBasicInfo.licensed,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.kybBasicInfo.licensed) = $event))
                      }, null, 8, ["is-readonly", "value"]),
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.b('form-radio-label'))
                      }, _toDisplayString(_ctx.$t("Да")), 3)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.b('form-radio', { active: !_ctx.kybBasicInfo.licensed })),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleLicensedChange(false)))
                    }, [
                      _createVNode(_component_SharedRadio, {
                        view: "light",
                        "checked-value": false,
                        "is-readonly": _ctx.isReadonly,
                        value: _ctx.kybBasicInfo.licensed,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.kybBasicInfo.licensed) = $event))
                      }, null, 8, ["is-readonly", "value"]),
                      _createElementVNode("p", {
                        class: _normalizeClass(_ctx.b('form-radio-label'))
                      }, _toDisplayString(_ctx.$t("Нет")), 3)
                    ], 2)
                  ], 2)
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"]),
            _createVNode(_component_SharedValidate, {
              class: _normalizeClass(_ctx.b('form-wide')),
              field: "telegram",
              value: _ctx.kybBasicInfo.telegram,
              "is-validate": _ctx.isValidate,
              "field-value": _ctx.kybBasicInfoFields.telegram,
              "onUpdate:fieldValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.kybBasicInfoFields.telegram) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.b('form-group'))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(_ctx.b('form-title'))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Телеграм для связи")), 1),
                    _hoisted_8
                  ], 2),
                  _createVNode(_component_UIInput, {
                    view: "light",
                    placeholder: "@username",
                    "is-telegram": true,
                    "is-readonly": _ctx.isReadonly,
                    "is-error": _ctx.isValidate && !_ctx.kybBasicInfoFields.telegram,
                    modelValue: _ctx.kybBasicInfo.telegram,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.kybBasicInfo.telegram) = $event))
                  }, null, 8, ["is-readonly", "is-error", "modelValue"])
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "value", "is-validate", "field-value"])
          ], 2)
        ], 2),
        _createVNode(_component_UIButton, {
          class: _normalizeClass(_ctx.b('continue')),
          label: "Продолжить",
          view: "main",
          disabled: _ctx.isContinueDisabled,
          type: "submit"
        }, null, 8, ["class", "disabled"])
      ], 34)
    ]),
    _: 1
  }, 8, ["class"]))
}